import {api} from './api';
import { planSlice } from '../containers/plans/planSlice';
export const planResourcesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planResourceDelete: builder.mutation({
			query: (planResourceId: number) => ({
				url: `planResources/${planResourceId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PlanInfo'],
		}),
		planResourceUpdate: builder.mutation({
			query: ({id, ...data}) => ({
				url: `planResources/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['PlanInfo'],
			// optimistic update
			onQueryStarted: (data, {dispatch}) => {
				dispatch(planSlice.actions.planResourceUpdateItem(data));
			},
		}),
	}),
});

export const { usePlanResourceDeleteMutation, usePlanResourceUpdateMutation } = planResourcesApi;
